import script from "./ClassificationTree.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassificationTree.vue?vue&type=script&setup=true&lang=js"

import "./ClassificationTree.vue?vue&type=style&index=0&id=4a1da186&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a1da186"]])

export default __exports__